import { Container, Typography } from '@mui/material';
import Page from '../components/Page';
import { ProductList } from '../sections/@dashboard/products';
import PRODUCTS from '../_mocks_/products';

export default function EcommerceShop() {
  return (
    <Page title="Dashboard: Locations | Minimal-UI">
      <Container maxWidth='xl'>
        <Typography variant="h4" sx={{ mb: 5 }}>
          Locations
        </Typography>
        <ProductList products={PRODUCTS} />
      </Container>
    </Page>
  );
}
